<template>
	<div class="screen" data-model-id="1493:251">

		<div class="div-3">
			<div style="width: 100%;display: flex;justify-content: center;">
				<div class="overlap-11">
					<Header />

					<CompanyIntro />
				</div>
			</div>
			<div class="overlap-9">

				<div class="text-wrapper-49">向全国各地提供专业法律综合服务</div>
				<div class="text-wrapper-50" style="margin-top: 10px;">倾注全力解决客户法律问题</div>
				
				<div class="overlap-10" style="margin-top: 40px;">
					<ServiceSection />
				</div>
				<div style="display: flex;align-items: center;margin-top: 20px;cursor: pointer;" @click="nav_gywm">
					<div class="text-wrapper-51" style="margin-right: 8px;" >探索更多内容</div>
					<img class="vector-6" alt="Vector" src="/img/vector-2.svg" />
				</div>
				
				
				<div class="rectangle-7" />
			</div>

			
			<div style="width: 1200px;margin: 0 auto;padding-top: 40px;margin-top: 50px;padding-bottom: 60px;">
				<div class="group-wrapper" style="padding-left: 100px;">
					<div class="group-35">
						<div class="text-wrapper-54">——团队风采</div>
						<div class="text-wrapper-55">
							行业引领精英团队
							<br />
							始终贯彻着为客户提供最优质服务的执业宗旨
						</div>
					</div>
				</div>
				<div class="group-28" style="padding-left: 100px;margin-top: 60px;">
					<!-- 田学东律师 -->
					<div class="lawyer-item lawyer-1">
						<div class="group-29-tian" />
						<div class="view-2 lawyer-overlay">
							<div class="overlap-group-7">
								<div class="group-30">
									<div class="text-wrapper-53">田学东律师</div>
								</div>
								<div class="group-29-tian-mask" />
							</div>
						</div>
					</div>
					<!-- 李律师 -->
					<div class="lawyer-item lawyer-3">
						<img class="group-29" alt="李律师" src="/img/group-15.png" />
						<div class="view-2 lawyer-overlay">
							<div class="overlap-group-7">
								<div class="group-30">
									<div class="text-wrapper-53">陈雅诗律师</div>
								</div>
								<div class="group-29-mask" />
							</div>
						</div>
					</div>
				
					<!-- 秦律师 -->
					<div class="lawyer-item lawyer-4">
						<div class="group-33" />
						<div class="view-2 lawyer-overlay">
							<div class="overlap-group-7">
								<div class="group-30">
									<div class="text-wrapper-53">李鸿枫律师</div>
								</div>
								<div class="group-33-mask" />
							</div>
						</div>
					</div>
				
					<!-- 张律师 -->
					<div class="lawyer-item lawyer-5">
						<div class="group-32" />
						<div class="view-2 lawyer-overlay">
							<div class="overlap-group-7">
								<div class="group-30">
									<div class="text-wrapper-53">王诗雅律师</div>
								</div>
								<div class="group-32-mask" />
							</div>
						</div>
					</div>
				
				
				
					<!-- 王律师 -->
					<div class="lawyer-item lawyer-6">
						<div class="group-34" />
						<div class="view-2 lawyer-overlay">
							<div class="overlap-group-7">
								<div class="group-30">
									<div class="text-wrapper-53">梁颖愉律师</div>
								</div>
								<div class="group-34-mask" />
							</div>
						</div>
					</div>
				</div>
				
			</div>
			<div class="group-27" style="cursor: pointer;padding-left: 100px;width: 1200px;margin: 0 auto;">
				<div class="text-wrapper-52">查看全部律师</div>
				<img class="vector-7" alt="Vector" src="/img/vector-2.svg" />
			</div>
			<NewsSection />
			
			
			<JoinUsSection />

		</div>
	</div>
</template>

<script>
	import ServiceSection from "./Screen/sections/ServiceSection.vue";
	import CompanyIntro from "./Screen/sections/CompanyIntro.vue";
	import Header from "./Screen/sections/OverlapGroupWrapperSubsection/Header.vue";
	import NewsSection from "./Screen/sections/NewsSection.vue";
	import JoinUsSection from "./Screen/sections/JoinUsSection.vue";
	import router from '../router';


	export default {
		name: "HomePage",
		components: {
			ServiceSection,
			CompanyIntro,
			Header,
			NewsSection,
			JoinUsSection,

		},
		methods:{
			nav_gywm(){
				router.push({
					path: '/about'
				})
			},
			nav_lslist(){
				router.push({
					path: '/TeamSpotlightPage'
				})
			}
		}
	};
</script>

<style>
	.screen {
		background-color: #ffffff;
		display: flex;
		flex-direction: row;
		justify-content: center;
		width: 100%;
	}

	.screen .div-3 {
		background-color: #ffffff;
		height: 3240px;
		overflow: hidden;
		position: relative;
		width: 1920px;
	}

	.screen .overlap-9 {
		background-color: #fafafa;
		  		background-image: url(/img/mask-group.png);
		background-size: 100% 100%;
		height: 540px;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		margin-top: 100px;
		
	}

	.screen .overlap-10 {
		/* height: 540px; */

		width: 100%;
		/* margin: auto; */
		display: flex;
		justify-content: center;
	}

	.screen .rectangle-7 {
		background-color: #ccad8c;
		height: 540px;
		left: 0;
		position: absolute;
		/* top: 0; */
		width: 28%;
		
	}

	.screen .text-wrapper-49 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 28px;
		font-weight: 400;
		/* left: 750px; */
		letter-spacing: 0;
		line-height: 36px;
		/* position: absolute; */
		/* top: 79px; */
		white-space: nowrap;
	}

	.screen .text-wrapper-50 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 20px;
		font-weight: 400;
		/* left: 840px; */
		letter-spacing: 0;
		line-height: 28px;
		/* position: absolute; */
		/* top: 127px; */
		white-space: nowrap;
	}

	.screen .text-wrapper-51 {
		color: #000000;
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 12px;
		font-weight: 400;
		/* left: 918px; */
		letter-spacing: 0;
		line-height: normal;
		/* position: absolute; */
		/* top: 491px; */
	}

	.screen .vector-6 {
		height: 8px;
		/* left: 998px; */
		object-fit: cover;
		/* position: absolute; */
		/* top: 497px; */
		width: 12px;
	}

	.overlap-11 {
		width: 1208px;
		height: 741px;
		/* margin: auto; */
		/* background-color: #ffff7f; */
		/* display: flex; */
		/* justify-content: center; */
		/* transform: translate(-50%, -50%); */
	}

	.screen .logo {
		height: 32px;
		left: 60px;
		object-fit: cover;
		position: absolute;
		top: 12px;
		width: 136px;
	}

	.screen .group-27 {
		width: 100%;
		height: 17px;
		display: flex;
		align-items: center;
		justify-content: center;
		/* margin-top: 30px; */
		padding-bottom: 30px;
		/* left: 918px; */
		/* position: absolute; */
		/* top: 1932px; */
		/* width: 94px; */
	}

	.screen .text-wrapper-52 {
		color: #000000;
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 12px;
		font-weight: 400;
		left: 0;
		letter-spacing: 0;
		line-height: normal;
		/* position: absolute; */
		top: 0;
		margin-right: 10px;
	}

	.screen .vector-7 {
		height: 7px;
		left: 80px;
		object-fit: cover;
		/* position: absolute; */
		top: 5px;
		width: 13px;
	}

	.screen .group-28 {
		height: 322px;
		/* left: 425px; */
		/* position: absolute; */
		/* top: 1580px; */
		width: 100%;
		display: flex;
		gap: 20px;
		margin-top: 60px;
	}

	.screen .lawyer-item {
		position: relative;
		width: 22%;
		height: 320px;
		cursor: pointer;
		transition: transform 0.3s ease;
	}

	.screen .lawyer-item:hover {
		transform: translateY(-5px);
	}

	.screen .group-29 {
		height: 320px;
		width: 199px;
		border-radius: 100px;
	}

	.screen .view-2 {
		background-color: #7a3529;
		border-radius: 100px;
		height: 320px;
		position: absolute;
		top: 0;
		left: 0;
		width: 199px;
		opacity: 0;
		transition: opacity 0.3s ease;
		pointer-events: none;
	}

	.screen .lawyer-overlay {
		opacity: 0;
		transition: opacity 0.3s ease;
	}

	.screen .lawyer-item:hover .lawyer-overlay {
		opacity: 1;
	}

	.screen .overlap-group-7 {
		border-radius: 100px;
		height: 320px;
		position: relative;
		width: 100%;
	}

	.screen .group-30 {
		height: 22px;
		/* left: 60px; */
		position: absolute;
		bottom: 44px;
		width: 100%;
		text-align: center;
	}

	.screen .text-wrapper-53 {
		color: #ffffff;
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 16px;
		font-weight: 400;
		/* left: 0; */
		letter-spacing: 0;
		line-height: normal;
		/* position: absolute; */
		/* top: 0; */
	}

	.screen .group-29-tian {
		background-image: url(/img/mask-group-2.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		width: 199px;
	}

	.screen .group-29-tian-mask {
		background-image: url(/img/mask-group-2.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-29-mask {
		background-image: url(/img/group-15.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-31 {
		background-image: url(/img/mask-group-2.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-32-mask {
		background-image: url(/img/mask-group-3.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-33-mask {
		background-image: url(/img/mask-group-4.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-34-mask {
		background-image: url(/img/mask-group-5.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		left: 0;
		opacity: 0.1;
		position: absolute;
		top: 0;
		width: 199px;
	}

	.screen .group-32 {
		background-image: url(/img/mask-group-3.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		width: 199px;
	}

	.screen .group-33 {
		background-image: url(/img/mask-group-4.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		width: 199px;
	}

	.screen .group-34 {
		background-image: url(/img/mask-group-5.png);
		background-size: 100% 100%;
		border-radius: 100px;
		height: 320px;
		width: 199px;
	}

	.screen .group-wrapper {
		height: 101px;
		/* left: 428px; */
		/* position: absolute; */
		/* top: 1441px; */
		width: 55%;
	}

	.screen .group-35 {
		height: 101px;
		position: relative;
		width: 564px;
	}

	.screen .text-wrapper-54 {
		color: var(--yxd-41k);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 12px;
		font-weight: 500;
		left: 0;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 0;
	}

	.screen .text-wrapper-55 {
		color: var(--x-1);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 28px;
		font-weight: 400;
		left: 0;
		letter-spacing: 0;
		line-height: 36px;
		position: absolute;
		top: 29px;
	}
</style>